import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function PermissionErrorScreen({ error, onRetry }) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-red-50 p-4">
      <div className="p-8 bg-white rounded-xl shadow-2xl w-full max-w-2xl text-center">
        <AlertTriangle className="mx-auto h-16 w-16 text-red-400 mb-4" />
        <h1 className="text-3xl font-bold text-red-600 mb-4">Database Permission Error</h1>
        <p className="text-gray-700 mb-6">{error}</p>
        <p className="text-gray-600 text-sm">This error is caused by your Firestore Security Rules. Please go to your Firebase project, navigate to **Firestore Database → Rules**, and replace the existing rules with the following:</p>
        <p className="text-gray-600 text-sm mb-2">Rules are versioned in <code className="bg-gray-100 px-1 rounded">firestore.rules</code> at the project root. Deploy with: <code className="bg-gray-100 px-1 rounded">firebase deploy --only firestore:rules</code></p>
        <pre className="bg-gray-800 text-white p-4 rounded-md text-left text-xs my-4 overflow-x-auto">
          <code>
{`// Summary: auth users read users/teams/okrs/okrs_fy2627;
// Admin writes okrs + okrs_fy2627 + teams;
// users/{id} updates: Admin or self;
// evaluations + evaluations_fy2627: employee, their manager (managerId), or Admin.`}
          </code>
        </pre>
        <button onClick={onRetry} className="w-full bg-blue-600 text-white font-semibold py-2.5 rounded-lg shadow-lg hover:bg-blue-700 transition-all">
          I have updated the rules. Try Again.
        </button>
      </div>
    </div>
  );
}
